import type { DiTypes } from "@iot-platform/core";

export const notebookTypes = Object.seal({
    repositories: {
        NotebookRepository: Symbol.for("NotebookRepository"),
        NotebookMessageRepository: Symbol.for("NotebookMessageRepository"),
    },
} satisfies DiTypes);
